import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";

function ClickableList({ title = "", onClick, visible }) {
  const [isVisible, setIsVisible] = useState(visible);
  return (
    <>
      {isVisible && (
        <div className="action-name-box">
          <div className="name-container-box">
            <div
              style={{
                width: 30,
                height: "100%",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={onClick}
            >
              <FaTimes />
            </div>
            <div
              style={{
                height: "100%",
                display: "flex",
                marginTop: -1,
                alignItems: "center",
              }}
            >
              {title}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ClickableList;
